import { render } from "./PricingView.vue?vue&type=template&id=4e40d7aa&scoped=true"
import script from "./PricingView.vue?vue&type=script&lang=js"
export * from "./PricingView.vue?vue&type=script&lang=js"

import "./PricingView.vue?vue&type=style&index=0&id=4e40d7aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e40d7aa"]])

export default __exports__